/* eslint-disable eqeqeq */
import React, { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { CompanyBox, Content } from "./styles";
import Button from "../../../../../../components/Button";
import api from "../../../../../../services/api";

interface TaxDefaultProps  {
  id: string | undefined;
  fantasyName: string | undefined;
  companyDocument: string | undefined;
  gatewayTax: string | undefined;
  gatewayReleaseMoneyDays: number | undefined;
  installmentTax: string | undefined;
}

const TaxDefaultContainer: React.FC<TaxDefaultProps> = ({
  id,
  fantasyName,
  companyDocument,
  gatewayTax,
  installmentTax,
  gatewayReleaseMoneyDays,
}) => {
  const [taxType, setTaxType] = useState<string | Blob>('');
  const [loading, setLoading] = useState<number>(0);

  const handleChange = useCallback((e) => {
    setTaxType(e.currentTarget.value);
  }, []);

  const defaultSelectValue = (moneyDays: number | undefined) => {
    let plan;
    moneyDays == 2 && (plan = 'plan-2');
    moneyDays == 15 && (plan = 'plan-15');
    moneyDays == 30 && (plan = 'plan-30');

    return plan;
  };

  const updateTax = useCallback(
    async (companyId) => {
      setLoading(1);

      try {
        await api.put(`companies/${companyId}/update-tax`, {
          gateway_release_payment: taxType,
        });
        setLoading(0);
        toast.success('Tarifas e prazos salvo com sucesso');
      } catch (error) {
        setLoading(0);
        toast.error('Ops! Algo saiu errado, tente novamente');
      }
    },
    [taxType],
  );

  return (
    <CompanyBox key={id}>
        <Content>
          <div className="row">
            <h5 className="header company-name col-sm-8 col-xs-12">
              {fantasyName}
            </h5>

            <h5 className="header company-document col-sm-4 col-xs-12">
              {companyDocument}
            </h5>
          </div>
          <div className="service-status row">
            <select
              name="tax"
              className="col-md-12 tax-type"
              onChange={handleChange}
              defaultValue={defaultSelectValue(gatewayReleaseMoneyDays)}
            >
              <option value="plan-2">
                {" "}
                2 dias (taxa de{" "}
                {gatewayReleaseMoneyDays == 2 ? gatewayTax : "6.9"}
                %)
              </option>
              <option value="plan-15">
                15 dias (taxa de{" "}
                {gatewayReleaseMoneyDays == 15 ? gatewayTax : "6.5"}
                %)
              </option>
              <option value="plan-30">
                30 dias (taxa de{" "}
                {gatewayReleaseMoneyDays == 30 ? gatewayTax : "5.9"}
                %)
              </option>
            </select>
          </div>
          <div className="company-footer-row row">
            <div className="credit-card-tax">
              <p className="credit-card-tax-rate">
                Taxa de parcelamento no cartão de crédito de {installmentTax}
                % ao mês.
              </p>
            </div>
            <div className="company-update-butto">
              <Button primaryPill onClick={() => updateTax(id)}>
                Atualizar
              </Button>
            </div>
          </div>
        </Content>
    </CompanyBox>
  );
};

export default TaxDefaultContainer;
